import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import { Helmet } from "react-helmet";
import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";

function Cex() {
  return (
    <div className="staking_txtcontent">
      <header className="newpage nft_new_page fixed_header p-0">
        {/* <Header /> */}
        <NewHead />
      </header>

      <div className="paddin_immner">
        <main className="carer_page">
          <span>
            <Helmet>
              <title>
                Defi Staking Platform Development | Defi Development Services
                |Beleaf Technologies
              </title>
              <link
                rel="canonical"
                href="https://beleaftechnologies.com/defi-staking-platform-development"
              />
              <meta
                name="title"
                content="Defi Staking Platform Development | Defi Development Services |Beleaf
                Technologies"
              />
              <meta
                name="description"
                content=" Discover the power of decentralized finance with DeFi staking platform development and unlock new opportunities for passive income. Our expert team delivers cutting-edge solutions to build secure and user-friendly staking platforms, revolutionizing the way you earn and engage with digital assets."
              />
              <meta
                name="keywords"
                content="defi development company, defi development services, defi protocols development, defi projects development companyDecentralized Finance Solutions, Decentralized Finance Solutions Provider, Decentralized Finance Development, DeFi Dapp Development, DeFi Smart Contract Development, DeFi Dapp, defi pulse,defi crypto, defi finance, defi lending,decentralized finance projects, decentralized finance regulations, DeFi"
              />
              <meta
                property="og:title"
                content=" Defi Development Company | Defi Development Services |Beleaf
                Technologies"
              />
              <meta property="og:site_name" content="Beleaf Technologies" />
              <meta
                property="og:url"
                content="https://beleaftechnologies.com/defi-staking-platform-development"
              />
              <meta
                property="og:description"
                content=" Discover the power of decentralized finance with DeFi staking platform development and unlock new opportunities for passive income. Our expert team delivers cutting-edge solutions to build secure and user-friendly staking platforms, revolutionizing the way you earn and engage with digital assets."
              />
              <meta property="og:type" content="website" />

              <meta name="twitter:card" content="summary" />
              <meta name="twitter:site" content="@BeleafTech" />
              <meta
                name="twitter:title"
                content="Defi Development Company | Defi Development Services |Beleaf
                Technologies"
              />
              <meta
                name="twitter:description"
                content=" Discover the power of decentralized finance with DeFi staking platform development and unlock new opportunities for passive income. Our expert team delivers cutting-edge solutions to build secure and user-friendly staking platforms, revolutionizing the way you earn and engage with digital assets."
              />

              <meta name="twitter:image:alt" content="Beleaf Technologies" />
            </Helmet>

            <div className="ourserveic_banner ourserveic_bannernft bg_img_none bg-white bg_defi_staking">
              {/* <div className="bg-overlay"></div> */}
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="staking_title">
                      <h1 className="">DeFi Staking Platform Development</h1>
                      <p>
                        start a profitable decentralized platform using high-end
                        <br />
                        DeFi Staking platform development services!
                      </p>
                      <Button
                        data-toggle="modal"
                        data-target="#myModal"
                        aria-label=" Get Free Consultation"
                      >
                        Get Free Consultation
                      </Button>
                      {/* <div className="pt-4 pb-0 mt-1 banner_text_section">
                          <Button>Demo</Button>
                        </div> */}
                    </div>
                  </div>
                  {/* <div className="col-lg-6">
                    <div className="image_position_section">
                      <img
                        src={BannerImage}
                        alt="Defi Staking Platform Development"
                        className="defi_nameee"
                      />
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <section className="section bg-light ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="">
                        DeFi Staking Platform Development Services
                      </h2>
                      <p className="">
                        Beleaf Technologies provides mission-driven services to
                        construct DeFi staking software that is enhanced with
                        market-leading functionality and institutional-grade
                        security. Our blockchain engineers and subject matter
                        experts collaborate closely to offer comprehensive
                        solutions that can accelerate your digital
                        transformation.
                        <br />
                        With our DeFi staking platform development services, you
                        can bridge the gap between your digital idea and
                        reality. We effectively provide projects that are
                        critical for achieving your business objectives, whether
                        you require a DeFi staking platform on TRON, Ethereum,
                        or any other blockchain.
                      </p>
                      <div className="button_why_devee">
                        <a href="https://wa.me/7904323274" target="_blank">
                          Connect With Us Via Whatsapp
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card_imgr_">
                      <img
                        src={require("../../image/Defistacking/sheagodot.webp")}
                        alt="Defi Staking Platform Development"
                        className="Defi"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white">
              <div className="container defi-staking_section">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="headingf_a secodary text_center_new">
                        DeFi Staking Platforms
                      </h2>
                      <p className="text-center">
                        When developing a DeFi staking platform, you can offer
                        DeFi services by selecting one of the options below.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_DEFI">
                      <span>01</span>
                      <h3>Exchange</h3>
                      <p>
                        Due to the large number of users on these platforms,
                        cryptocurrency exchanges have entered the staking
                        sector. To provide DeFi staking services, you can use
                        your existing crypto exchange or create a new one.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_DEFI">
                      <span>02</span>
                      <h3>Wallet</h3>
                      <p>
                        You can use a crypto wallet to provide DeFi staking
                        services to your users, just like many other businesses.
                        It necessitates that you supply your consumers with a
                        safe and simple wallet in which to take their assets.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_DEFI">
                      <span>03</span>
                      <h3>Staking-as-a-Service Platform</h3>
                      <p>
                        Unlike exchanges and wallets, which also serve as
                        trading and storage platforms, staking-as-a-service
                        software is dedicated solely to staking. Soft staking is
                        used on these platforms.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light bg_covere ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="first_section_crypto second_section_crypto_p">
                      <h2 className="">Workflow of DeFi Staking Platform</h2>
                      <p className="">
                        Decentralized Finance uses smart contracts to govern and
                        conduct transactions on the platform. Participants must
                        stake their cryptocurrency assets in a common pool and
                        give liquidity to millions of users. By permitting the
                        lending and borrowing of cash, stakeholders can receive
                        attractive interest rates and incentives in the form of
                        governance tokens.
                        <br />
                        DeFi staking solutions play an important role in
                        providing players with access to transparent platforms
                        that are free of middlemen involvement. This gives the
                        stakeholders more control over their assets and
                        earnings. By putting their assets in a consolidated
                        staking pool, a sizable cryptocurrency fund is created,
                        benefiting members and allowing them to earn higher
                        returns on their investments. Utilize outstanding Defi
                        staking development services to construct and launch a
                        highly profitable project right away!
                      </p>
                      <div className="button_why_devee">
                        <a href="https://wa.me/7904323274" target="_blank">
                          Connect Us Via Whatsapp
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card_imgr_">
                      <img
                        src={require("../../image/Defistacking/setpic.webp")}
                        alt="Defi Staking Platform Development"
                        className="Defi"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-blue bg-blue_shade grid_ful_height_tab">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="content_secion_scor">
                      <h2>
                        Numerous Opportunities To Earn Rewards With Defi Staking
                        Platform Development
                      </h2>
                      <p>
                        As the owner of a DeFi staking platform, you can select
                        the mechanism for rewarding your customers for staking
                        their assets on your platform.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_seperate">
                      <img
                        src={require("../../image/Defistacking/claim.webp")}
                        alt="Defi Staking Platform Development"
                        className="Defi"
                      />
                      <h4>Claim</h4>
                      <p>
                        This activity entails compensating users for locking
                        their assets on your site for a specified period of
                        time. The rewards are determined based on the assets
                        that are locked - larger locked-in assets result in
                        higher rewards that are directly delivered to the users'
                        wallets.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_seperate">
                      <img
                        src={require("../../image/Defistacking/task-actions.webp")}
                        alt="Defi Staking Platform Development"
                        className="Defi"
                      />
                      <h4>Delegate</h4>
                      <p>
                        It includes the participation of a fund manager with
                        significant capital. Profits from this platform are
                        reinvested, and payouts are dispersed evenly among
                        users. The fund manager gets compensated for his
                        services and knowledge.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="card_seperate">
                      <img
                        src={require("../../image/Defistacking/correction.webp")}
                        alt="Defi Staking Platform Development"
                        className="Defi"
                      />
                      <h4>Validate</h4>
                      <p>
                        It entails rewarding users for certifying the
                        blockchain. The validation duties provided to users are
                        precisely proportionate to their assets. Users with more
                        assets are allocated more validation jobs, resulting in
                        higher rewards.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-4"></div>
                  <div className="col-md-6 col-lg-4 button_content">
                    <div className="card_seperate h-auto max-h-fit w-100_md">
                      <Button data-toggle="modal" data-target="#myModal">
                        Initiate With Proposal!
                      </Button>
                    </div>
                  </div>
                  <div className="col-lg-4"></div>
                </div>
              </div>
            </section>
            <section className="section bg-light bg_line defi-staking-list inner_card_height_none grid_ful_height_tab">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_center_new">
                        Perks of DeFi Staking Platform Development Services
                      </h2>
                      <p className="text-center">
                        You should be aware of the following benefits of trading
                        on the DeFi Staking platform today.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="card_bg_whute">
                  <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Transparency</h3>
                        <p>The transactions are transparent to the core.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>User-friendliness </h3>
                        <p>The system is user-friendly.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>High ROI</h3>
                        <p>Users can earn a high ROI.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Better Liquid Flow</h3>
                        <p>The environment provides a lot of liquidity.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Access Decentralized Banking Solutions</h3>
                        <p>
                          Users can gain access to Decentralized Banking
                          Solutions.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Eco-Friendly Solutions</h3>
                        <p>Users will find it to be a green option.</p>
                      </div>
                    </div>
                    <div className="col-md-6 col-lg-6">
                      <div className="card_">
                        <h3>Unlock Other Cryptocurrency Use-Cases</h3>
                        <p>
                          Users can now unlock additional cryptocurrency
                          use-cases.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-lg-6">
                      <div className="footer_cerd">
                        <div className="row">
                          <div className="col-lg-12">
                            <h2>
                              Are you looking to develop a DeFi staking platform
                            </h2>
                            <Button
                              data-toggle="modal"
                              data-target="#myModal"
                              aria-label="Contact Us"
                            >
                              Contact Us
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="section bg-white">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_center_new">
                        Learn About the Most Popular Tokens in Use
                      </h2>
                      <p className="text-center">
                        Some new Defi tokens have emerged in the market
                        throughout time. You can also add your token to this
                        list by launching your own platform.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/uniswap.webp")}
                        alt="Defi Staking Platform Development"
                        className=""
                      />
                      <h3>Uniswap</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/compound.webp")}
                        alt="Defi Staking Platform Development"
                        className=""
                      />
                      <h3>Compound</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/yearn-finance.webp")}
                        alt="Defi Staking Platform Development"
                        className=""
                      />
                      <h3>Yearn Finance</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/Group_1_yz9c61.webp")}
                        alt="Defi Staking Platform Development"
                        className=""
                      />
                      <h3>Cream</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/Frame_1504_icaasa.webp")}
                        alt="Defi Staking Platform Development"
                        className=""
                      />
                      <h3>Chainlink</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-lg-12">
                    <div className="first_section_crypto">
                      <h2 className="text_center_new">
                        Our Advanced Tech Stack
                      </h2>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/ethereum-eth-logo.webp")}
                        alt="Defi Staking Platform Development"
                      />
                      <h3>Ethereum</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/polkadot-new-dot.webp")}
                        alt="Defi Staking Platform Development"
                      />
                      <h3>Polkadot</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/solana-sol-logo.webp")}
                        alt="Defi Staking Platform Development"
                      />
                      <h3>Solana</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/ai/binance.webp")}
                        alt="Defi Staking Platform Development"
                      />
                      <h3>Binance</h3>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="icon_defi_col">
                      <img
                        src={require("../../image/Defistacking/tron-trx-logo.webp")}
                        alt="Defi Staking Platform Development"
                      />
                      <h3>TRON</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-white ">
              <div className="container">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="block_ing">
                      <img
                        src={require("../../image/Defistacking/vmeqlb.webp")}
                        alt="Defi Staking Platform Development"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="first_section_crypto">
                      <h2 className="headingf_a secodary">
                        DeFi Staking Platform Development Process we adhere to
                      </h2>
                      <p className="">
                        Creating a stable DeFi Staking platform for your
                        blockchain business by employing Beleaf Technologies’s
                        experts strongly assists you to build your complete
                        project in a more enhanced manner. We develop your DeFi
                        staking website under the following process mentioned
                        below.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-12 mt-5">
                    <div className="row justify-content-center grid_ful_height_tab">
                      <div className="col-md-6 col-lg-4">
                        <div className="card_col_sectop">
                          <img
                            src={require("../../image/Defistacking/check-list_hrrq8u.webp")}
                            alt="Defi Staking Platform Development"
                          />
                          <h5>Inquiry</h5>
                          <p>
                            We investigate your company's requirements to
                            identify the best solution. Every business case is
                            unique and necessitates a customized strategy.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="card_col_sectop">
                          <img
                            src={require("../../image/Defistacking/planning_qclugu.webp")}
                            alt="Defi Staking Platform Development"
                          />
                          <h5>Planning</h5>
                          <p>
                            Having your DeFi product delivered on time is
                            essential to business success in an unpredictable
                            cryptocurrency industry. Our project managers will
                            meticulously plan each development stage to
                            guarantee that the final product meets all of your
                            business requirements and arrives on schedule to the
                            end customer.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="card_col_sectop">
                          <img
                            src={require("../../image/Defistacking/development_ufyzcs.webp")}
                            alt="Defi Staking Platform Development"
                          />

                          <h5>Development</h5>
                          <p>
                            At this point, our battle-tested developers
                            transform your business concept into a full-fledged
                            DeFi solution.
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="card_col_sectop">
                          <img
                            src={require("../../image/Defistacking/testing_n0mih2.webp")}
                            alt="Defi Staking Platform Development"
                          />

                          <h5>Implementation</h5>
                          <p>
                            Your solution is now ready for deployment after
                            extensive testing. You will receive technical
                            support from Beleaf for the duration of your
                            project.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="section bg-light">
              <div className="container">
                <div className="contanineee_circle">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="first_section_crypto colo_white card_CTAA">
                        <h2 className="">
                          Begin Your Most Advanced DeFi Staking Platform
                          Development Wisely to Attract the Market!
                        </h2>
                        <a
                          href="tel:+91 80567 86622"
                          target="_blank"
                          className="grabcall"
                        >
                          Start A Conversation{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="section bg-white pb-0">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="first_section_crypto ">
                      <h2 className="text-center text_center_new">
                        Why Should You Build Your DeFi Staking Platform
                        Development With Us?
                      </h2>
                      <p className="text-center">
                        You can rely on a team of finance and technological
                        specialists with real-world experience establishing DeFi
                        success stories when you collaborate with Beleaf.
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <img
                          src={require("../../image/Defistacking/ww6o36.webp")}
                          alt="Defi Staking Platform Development"
                        />
                      </div>
                      <div className="col-lg-6">
                        <ul className="list_fetures redult_memene">
                          <li>
                            <h4>Meaningful Results</h4>
                            <p>
                              We make a visible difference. We make certain that
                              you see a return on your investment.
                            </p>
                          </li>
                          <li>
                            <h4>Complete Assistance</h4>
                            <p>
                              Our work does not end with the release of the
                              product. We offer comprehensive post-delivery
                              services so you may focus on your growth.
                            </p>
                          </li>
                          <li>
                            <h4>Rapid Progress</h4>
                            <p>
                              We create goods that are tailored to your target
                              demographic. A well-planned roadmap ensures
                              seamless and rapid development and deployment.
                            </p>
                          </li>
                          <li>
                            <h4>Team of Experts</h4>
                            <p>
                              We have 500 specialists who can assist you
                              optimize your product, recommend the optimal tech
                              strategy, and even set up communities and
                              campaigns.
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <Section id="about why new_faq bg_white CEX_faq">
              <section className="section bg_white CEX_faq" id="">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 d-flex justify-content-center align-items-center">
                      <div className="whybelaf faq">
                        <h2 className="">
                          Frequently asked <br />
                          Question
                        </h2>
                        <p></p>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="comtent">
                        <div id="main">
                          <div className="container">
                            <div className="accordion" id="faq">
                              <div className="card">
                                <div className="card-header" id="faqhead1">
                                  <a
                                    href="#"
                                    className="btn btn-header-link"
                                    data-toggle="collapse"
                                    data-target="#faq1"
                                    aria-expanded="true"
                                    aria-controls="faq1"
                                  >
                                    What is DeFi Staking?
                                  </a>
                                </div>

                                <div
                                  id="faq1"
                                  className="collapse show"
                                  aria-labelledby="faqhead1"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Defi staking allows a participant to
                                    validate any of the Defi-based protocols.
                                    Defi staking is usually done to increase the
                                    customer's earnings.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead2">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq2"
                                    aria-expanded="true"
                                    aria-controls="faq2"
                                  >
                                    Is DeFi staking effective?
                                  </a>
                                </div>

                                <div
                                  id="faq2"
                                  className="collapse"
                                  aria-labelledby="faqhead2"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    It's an excellent strategy to encourage
                                    cryptocurrency investors to keep their
                                    assets while generating big returns. DeFi
                                    staking is more appealing to investors since
                                    it offers larger returns than a typical
                                    savings account.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead3">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq3"
                                    aria-expanded="true"
                                    aria-controls="faq3"
                                  >
                                    Why choose beleaf a your DeFi staking
                                    development?
                                  </a>
                                </div>

                                <div
                                  id="faq3"
                                  className="collapse"
                                  aria-labelledby="faqhead3"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Beleaf creates Defi staking with features
                                    such as on-time product delivery,
                                    post-delivery help, revenue-generating
                                    traits recommended by experts, bug-free
                                    compliance, extra emphasis on security
                                    measures, and a Blockchain-powered
                                    customisable staking platform.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead4">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq4"
                                    aria-expanded="true"
                                    aria-controls="faq4"
                                  >
                                    How DeFi platform Works?
                                  </a>
                                </div>

                                <div
                                  id="faq4"
                                  className="collapse"
                                  aria-labelledby="faqhead4"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Cryptos are held up in particular Smart
                                    Contracts; investors will be created
                                    validators evaluating the process's
                                    authenticity. The Validators will receive
                                    substantial compensation for participating
                                    in validation. Validators will be fined as
                                    well for carrying out invalid transactions.
                                  </div>
                                </div>
                              </div>
                              <div className="card">
                                <div className="card-header" id="faqhead5">
                                  <a
                                    href="#"
                                    className="btn btn-header-link collapsed"
                                    data-toggle="collapse"
                                    data-target="#faq5"
                                    aria-expanded="true"
                                    aria-controls="faq5"
                                  >
                                    What are the advantages of DeFi Staking?
                                  </a>
                                </div>

                                <div
                                  id="faq5"
                                  className="collapse"
                                  aria-labelledby="faqhead5"
                                  data-parent="#faq"
                                >
                                  <div className="card-body">
                                    Defi staking provides Ease of access to
                                    complicated decentralized services, Passive
                                    income to convicts, Very low participation
                                    price, Smart Contract protected protocol,
                                    and Leveraged Liquidity.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </Section>
          </span>
          {/* <Commonpage /> */}
        </main>
      </div>

      {/* <Footer /> */}
      <ServiceFooter />
    </div>
  );
}

export default Cex;
